export default "__VITE_ASSET__29e8b8f7__"